import { FormLabel } from '../FormLabel';
import { Label } from '@headlessui/react';
import { classNames } from '@src/utils/classNames';
import type { ComboboxMultipleProperties } from '../ComboboxMultiple';

export type ComboboxTitleProperties<T> = Pick<
  ComboboxMultipleProperties<T>,
  'title' | 'TitleComponent' | 'required' | 'infoText'
> & { readonly isValid?: boolean; readonly className?: string };

export function ComboboxTitle<T>({
  title,
  TitleComponent,
  required,
  className,
  infoText,
  isValid = true,
}: ComboboxTitleProperties<T>) {
  if (!title) {
    return null;
  }

  return (
    <Label>
      <FormLabel
        label={title}
        required={required}
        valid={isValid}
        className={classNames('mb-4', className)}
        infoText={infoText}
        Component={TitleComponent}
      />
    </Label>
  );
}
